<div [class]="theme">
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <ft-intro-section
          edsCol
          [showCta]="content?.cards?.length > 0 ? false : true"
          [content]="content"
        ></ft-intro-section>
      </div>
      <ng-container *ngFor="let cardGroup of this.cards; last as isLast">
        <div
          edsRow
          [edsSpacing]="(isMobile$ | async) || isLast ? 'none' : 'md'"
        >
          <div edsCol>
            <div edsSubGrid="layout-1" edsSubGridGap="lg">
              <eds-thumbnail
                *ngFor="let card of cardGroup"
                [eventId]="card.eventId"
                [eventParams]="card.eventParams"
                [hasBorders]="true"
                [hasShadows]="true"
                [headingLevel]="2"
                [layoutSearch]="false"
                [layoutCompact]="
                  sectionType === 'thumbnail_cards_compact' ? true : false
                "
                [title]="card.title"
                [body]="card.content"
                [buttonText]="card.link?.displayText"
                [previewSrc]="
                  sectionType === 'thumbnail_cards_compact' ? null : card.imgSrc
                "
                [docTypeSrc]="card.docTypeSrc"
                [href]="card.link?.url"
                [titleLink]="card.link?.url"
                [isNewWindow]="card.link?.target === '_blank'"
                [externalLink]="card.link?.external"
                [trackDownloads]="card.link?.enableDownloadTracking"
                [trackImpression]="card.link?.enableImpressionTracking"
              >
              </eds-thumbnail>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
